import { useEffect } from "react";
import classNames from "classnames";
import { useSegmentReFetch } from "context";
import { Button } from "components/atoms";
import { useGetCourseworkQuery } from "services/homeApi";
import { SelfPacedCourseworkDetailCardSection } from "../SelfPacedCourseworkDetailCardSection";
import { reStructureSelfPacedSegment } from "utils/functions/selfPacedCourseWorkRestructure";
import { decodeToken } from "utils/functions/decodeToken";
import { MCAT_TEST_TYPE } from "utils/constants";
import "./index.scss";

interface IProps {
  theme: "light" | "dark";
}

export const SelfPacedCourseworks = ({ theme }: IProps) => {
  const { data, setData, page, setPage, subject } =
    useSegmentReFetch();

  const payload = decodeToken();

  const testtype =
    payload && payload.hasOwnProperty("testtype") && payload.testtype;

  const {
    data: remoteData,
    isLoading,
    isFetching,
    isError,
  } = useGetCourseworkQuery({
    page: page,
    ...(testtype === MCAT_TEST_TYPE ? { subject: subject } : {}),
  });

  const compareArrayOfObjects = (fetchArray: any, existArray: any) => {
    let isNewData = true;
    for (let segment of existArray) {
      if (
        fetchArray[0].LearningTrackGuid ===
        segment.LearningTrackGuid
      ) {
        isNewData = false;
      }
    }
    return isNewData;
  };

  useEffect(() => {
    if (remoteData && remoteData.LearningTracks && page === 1) {
      const deStructuredArray = reStructureSelfPacedSegment(remoteData);
      setData([...deStructuredArray]);
    } else if (
      remoteData &&
      remoteData.LearningTracks &&
      Array.isArray(remoteData.LearningTracks) &&
      compareArrayOfObjects(remoteData.LearningTracks, data)
    ) {
      const deStructuredArray = reStructureSelfPacedSegment(remoteData);
      setData((prev) => [...prev, ...deStructuredArray]);
    }
  }, [page, remoteData]);

  return (
    <>
      <div className={classNames("self-paced-home-page-detail-card-section")}>
        <SelfPacedCourseworkDetailCardSection
          learningTracks={data}
          theme={theme}
          isLoading={isLoading}
          isError={isError}
          isFetching={isFetching}
        />
      </div>
      {isError || isLoading ? null : (
        <div className={classNames("home-page-bottom-btn-section")}>
          <Button
            icon={false}
            type="score"
            styles="self-paced-bottom-button-section-btn"
            label="Load More Segments"
            onClick={() => setPage((prev) => prev + 1)}
            isLoading={isFetching}
            isDisabled={remoteData?.Total === data.length}
          />
        </div>
      )}
    </>
  );
};
